import { ComponentType } from 'react';
import { ReactComponent as PathIcon } from 'assets/paths-icon.svg';
import { ButtonType } from '@mm/state/model/ButtonModel';

export type TextWidgetButtonDefinition = {
  type: ButtonType;
  text: string;
  iconClassList?: string;
  iconComponent?: ComponentType<any>;
};

export const textWidgetButtons: {
  [key: string]: TextWidgetButtonDefinition;
} = {
  path: {
    type: ButtonType.PAGE,
    text: 'Dialogue',
    iconComponent: PathIcon,
  },
  dialogue: {
    type: ButtonType.PAGE,
    text: 'Dialogue',
    iconComponent: PathIcon,
  },
  phone: {
    type: ButtonType.CALL,
    text: 'Phone',
    iconClassList: 'fa fa-phone',
  },
  url: {
    type: ButtonType.URL,
    text: 'URL',
    iconClassList: 'fas fa-external-link-alt',
  },
  handover: {
    type: ButtonType.HANDOVER,
    text: 'Handover',
    iconClassList: 'fas fa-hands-helping',
  },
};

export const useTextWidgetButtonsList = ({
  forAds,
  isOnboardingRoute,
  disabledButtonTypes = [],
}: {
  forAds?: boolean;
  isOnboardingRoute?: boolean;
  disabledButtonTypes?: ButtonType[];
}): TextWidgetButtonDefinition[] => {
  return [
    ...[textWidgetButtons.path],
    ...(forAds ? [] : [textWidgetButtons.phone]),
    textWidgetButtons.url,
    ...(isOnboardingRoute || forAds ? [] : [textWidgetButtons.handover]),
  ].filter(button => !disabledButtonTypes?.includes(button.type));
};
